<template>
<div>
  <CountryView />
 <section class="blogbeep">
   <h2 class="question">Author: Amina</h2>
   <div class="virg">
<div class="dope">
  <div class="dopeson">
<img src="@/assets/images/profill.jpg" alt="" width="260px" height="260px">
<h2 class="cook">Amina</h2>
</div>
</div>

<div class="dapes">
<h2>Search</h2>
<form class="creation">
<label for="search" class="fair"  ></label> 
<input type="text" id="search" placeholder="search" class="render">
<label for="sam" class="grow" ></label> 
<input type="text" id="search" placeholder="" class="clever">
</form>

</div>
 </div>
 </section>
 
  <section class="blogbeep1">
   <div class="virg1">
 <div class="jmartins">

  <div class="clerk">
<img src="@/assets/images/Africa1.jpg" class="villa" alt="" width="230px" height="230px">
 <div class="croon">
<div class="dube">  <li class="lucky"><a href="Lokas">
  BUSINESS</a></li></div>
<div class="dube1">  <li class="lucky1"><a href="Virginia">
  Why SwyChr Is the Best App  to Send Money from Virginia  to Over 18 African 
  Countries</a></li></div>
<p class="sabath">Are you looking for the easiest way to  send money
   from Virginia  to anywhere in   Africa without long...</p>
 <div class="pius">
<p class="pius-son">December 29, 2025 </p> <span class="pius-cuzo">
By </span>   <span class="pius-cuzo1"><li class="jolie"><a href="Amina">Amina</a></li></span>
</div> 
</div>
</div>

   <div class="clerk">
<img src="@/assets/images/Africa1.jpg" class="villa" alt="" width="230px" height="230px">
 <div class="croon">
<div class="dube">  <li class="lucky"><a href="Lokas">
  BUSINESS</a></li></div>
<div class="dube1">  <li class="lucky1"><a href="Texas">
  Why SwyChr Is the Best App  to Send  Money from Texas  to Over 18 African 
  Countries</a></li></div>
<p class="sabath">Are you looking for the easiest way to send money from Texas
  to  anywhere in   Africa without long...</p>
 <div class="pius">
<p class="pius-son">December 29, 2025 </p> <span class="pius-cuzo">
By </span>   <span class="pius-cuzo1"><li class="jolie"><a href="Amina">Amina</a></li></span>
</div> 
</div>
</div>

   <div class="clerk">
<img src="@/assets/images/Africa1.jpg" class="villa" alt="" width="230px" height="230px">
<div class="croon">
<div class="dube">  <li class="lucky"><a href="Lokas">BUSINESS</a></li></div>
<div class="dube1">  <li class="lucky1"><a href="Southcarolina">
  Why SwyChr Is the Best App  to Send  Money from South Carolina to Over  18 African</a></li></div>
<p class="sabath1">Are you looking for the easiest way to  send money
  from South Carolina to anywhere in  Africa without...</p>
 <div class="pius">
<p class="pius-son">December 29, 2025 </p> <span class="pius-cuzo">
By </span>   <span class="pius-cuzo1"><li class="jolie"><a href="Amina">Amina</a></li></span>
</div>
</div> 
</div>


<div class="clerk">
<img src="@/assets/images/Africa1.jpg" class="villa" alt="" width="230px" height="230px">
<div class="croon">
<div class="dube">  <li class="lucky"><a href="Lokas">
  BUSINESS</a></li></div>
<div class="dube1">  <li class="lucky1"><a href="Ohio">
  Why SwyChr Is the Best App  to Send  Money from Ohio  to Over 18 African 
  Countries</a></li></div>
<p class="sabath">Are you looking for the easiest way to send money
   from Ohio to anywhere in   Africa without long...</p>
 <div class="pius">
<p class="pius-son">December 29, 2025 </p> <span class="pius-cuzo">
By </span>   <span class="pius-cuzo1"><li class="jolie"><a href="Amina">Amina</a></li></span>
</div> 
</div>
</div>

<div class="clerk">
<img src="@/assets/images/Africa1.jpg" class="villa" alt="" width="230px" height="230px">
<div class="croon">
<div class="dube">  <li class="lucky"><a href="Lokas">
  BUSINESS</a></li></div>
<div class="dube1">  <li class="lucky2"><a href="Northcarolina">
  Why SwyChr Is the Best App  to Send Money from North Carolina to Over 18 African 
  Countries</a></li></div>
<p class="sabath2">Are you looking for the easiest way to send money from North  Carolina
  to anywhere in  Africa without...</p>
 <div class="pius2">
<p class="pius-son2">December 29, 2025 </p> <span class="pius-cuzo2">
By </span>   <span class="pius-cuzo3"><li class="jolie2"><a href="Amina">Amina</a></li></span>
</div> 
</div>
</div>


<div class="clerk">
<img src="@/assets/images/Africa1.jpg" class="villa" alt="" width="230px" height="230px">
<div class="croon">
<div class="dube">  <li class="lucky"><a href="Lokas">BUSINESS</a></li></div>
<div class="dube1">  <li class="lucky1"><a href="Newyork">
  Why SwyChr Is the Best App  to Send  Money from New York to Over 18  African 
  Countries</a></li></div>
<p class="sabath1">Are you looking for the easiest way to  send money
  from New York to anywhere in  Africa without...</p>
 <div class="pius">
<p class="pius-son">December 29, 2025 </p> <span class="pius-cuzo">
By </span>   <span class="pius-cuzo1"><li class="jolie"><a href="Amina">Amina</a></li></span>
</div> 
</div>
</div>


<div class="clerk">
<img src="@/assets/images/Africa1.jpg" class="villa" alt="" width="230px" height="230px">
<div class="croon">
<div class="dube">  <li class="lucky"><a href="Lokas">
  BUSINESS</a></li></div>
<div class="dube1">  <li class="lucky1"><a href="Michigan">
  Why SwyChr Is the Best App  to Send  Money from Michigan  to Over 18 African 
  Countries</a></li></div>
<p class="sabath">Are you looking for the easiest way to  send money
   from  Michigan to anywhere in  Africa without long...</p>
 <div class="pius">
<p class="pius-son">December 29, 2025 </p> <span class="pius-cuzo">
By </span>   <span class="pius-cuzo1"><li class="jolie"><a href="Amina">Amina</a></li></span>
</div> 
</div>
</div>

<div class="clerk">
<img src="@/assets/images/Africa1.jpg" class="villa" alt="" width="230px" height="230px">
<div class="croon">
<div class="dube">  <li class="lucky"><a href="Lokas">
  BUSINESS</a></li></div>
<div class="dube1">  <li class="lucky1"><a href="Maryland">
  Why SwyChr Is the Best App  to Send  Money from Maryland  to Over 18 African 
  Countries</a></li></div>
<p class="sabath">Are you looking for the easiest way to send money from Maryland
  to anywhere in  Africa without long bank queues, high...</p>
 <div class="pius">
<p class="pius-son">December 29, 2025 </p> <span class="pius-cuzo">
By </span>   <span class="pius-cuzo1"><li class="jolie"><a href="Amina">Amina</a></li></span>
</div>
</div> 
</div>


<div class="clerk">
<img src="@/assets/images/Africa1.jpg" class="villa" alt="" width="230px" height="230px">
<div class="croon">
<div class="dube">  <li class="lucky"><a href="Lokas">BUSINESS</a></li></div>
<div class="dube1">  <li class="lucky1"><a href="Louisana">
  Why SwyChr Is the Best App  to Send Money from Louisana  to Over 18 African
  Countries</a></li></div>
<p class="sabath1">Are you looking for the easiest way to  send money
  from South Louisana to anywhere in  Africa without long bank queues, high...</p>
 <div class="pius">
<p class="pius-son">December 29, 2025 </p> <span class="pius-cuzo">
By </span>   <span class="pius-cuzo1"><li class="jolie"><a href="Amina">Amina</a></li></span>
</div>
</div> 
</div>

 </div> 

  <div class="clerk1">
   <div class="tross">
  <h2>Feature Post</h2>
  <div class="clerk1">
  <img src="@/assets/images/Africa1.jpg" class="villa1" alt="" width="130px" height="130px">  
<div class="croon">
<div class="dube">  <li class="lucky"><a href="Lokas">BUSINESS</a></li></div>
<div class="dube1">  <li class="lucky1new"><a href="Southcarolina">
  Why SwyChr Is the Best App  to Send  Money from South Carolina to Over  18 African</a></li></div>
 <div class="pius8">
<p class="pius-son8">December 29, 2025 </p> <span class="pius-cuzo8">
By </span>   <span class="pius-cuzo18"><li class="jolie8"><a href="Amina">Amina</a></li></span>
</div>
</div> 
</div> 

   <div class="clerk1">
<img src="@/assets/images/Africa1.jpg" class="villa1" alt="" width="130px" height="130px">
 <div class="croon">
<div class="dube">  <li class="lucky"><a href="Lokas">
  BUSINESS</a></li></div>
<div class="dube1">  <li class="lucky1new"><a href="Texas">
  Why SwyChr Is the Best App  to Send  Money from Texas  to Over 18 African 
  Countries</a></li></div>
 <div class="pius8">
<p class="pius-son8">December 29, 2025 </p> <span class="pius-cuzo8">
By </span>   <span class="pius-cuzo18"><li class="jolie8"><a href="Amina">Amina</a></li></span>
</div> 
</div>
</div>

  <div class="clerk1">
<img src="@/assets/images/Africa1.jpg" class="villa1" alt="" width="130px" height="130px">
<div class="croon">
<div class="dube">  <li class="lucky"><a href="Lokas">BUSINESS</a></li></div>
<div class="dube1">  <li class="lucky1new"><a href="Southcarolina">
  Why SwyChr Is the Best App  to Send  Money from South Carolina to Over  18 African</a></li></div>
 <div class="pius8">
<p class="pius-son8">December 29, 2025 </p> <span class="pius-cuzo8">
By </span>   <span class="pius-cuzo18"><li class="jolie8"><a href="Amina">Amina</a></li></span>
</div>
</div> 
</div>

 </div>
 </div>
  </div>

  </section>
  <FooterView />
 </div>
 </template>  
 
  <script setup>
import CountryView from '@/components/CountryView.vue';
import FooterView from '@/components/FooterView.vue';   
 </script>

 <style scoped>
.question{
  display: center;
  text-align: center;
  justify-content: center;
   color: black;
   font-size: 55px;
   font-weight: 750;
   text-align: justify;
   margin-left: 30px;
}


.blogbeep{
  padding: 50px 0;
  text-align: center;
  width:100%; 
  margin: 0 auto;
}

.virg{
  display:inline-flex;
  align-items: center;
  text-align: center; 
  justify-content: center;
  font-family: Montserrat;
font-size: 24px;
font-style: normal;
font-weight: 600;
line-height: 120%;

}

.dope{
  background-color: #FFEBE2;
  width: 800px;
  height: 350px;
  border-radius: 20px;
  margin-right: 50px;
  margin-top: 20px;
}

.dope img{
  border-radius: 15px;
 
}

.dopeson{
  display: inline-flex;
  margin: 30px;
  margin-right: 370px;
}

.cook{
  color: #000;
   justify-content: center;
  font-family: Montserrat;
font-size: 40px;
font-style: normal;
font-weight: 700;
line-height: 120%;
margin-left: 20px;
padding-top: 70px;
}

.dapes{
  box-shadow: 10px 10px 10px 10px rgba(0, 0, 0, 0.2);
  background-color: #FFFFFF;
  width: 400px;
  height: 200px;
  border-radius: 20px; 
  margin-bottom: 120px;
   align-items: center;
  text-align: center; 
  justify-content: center;
  color: #000;
}

.fair{
  color: #000;
}

.render{
 width: 200px; 
}

.creation{
  display: inline-flex;
}

.clever{
  width: 30px;
  background-color: #7A1FA1;
  border: none;
  color: #FFFFFF;
}


.blogbeep1{
  padding: 50px 0;
  text-align: center;
  width:100%; 
  margin: 0 auto;
  background-color: #ffffff;
}

.virg1{
  display:inline-flex;
  align-items: center;
  text-align: center; 
  justify-content: center;
  font-family: Montserrat;
font-size: 24px;
font-style: normal;
font-weight: 600;
line-height: 120%;
margin-right: 200px;
max-width: 100%;
margin-left: 50px;
}

.jmartins{
  display: block;
  font-size: 20px;
  text-align: center;
  justify-content: center;
  align-items: center;
   color: #000;
   background-color: #FFFFFF;
}

.studies{
  color: #000;
  border-radius: 15px;
  margin: 0;
  padding: 0;
  margin-bottom: 0;
     padding-bottom: 0;
     padding-top:0;
     margin-top: 0; 
}

.clerk{
  display: inline-flex;
}

.clerk1{
  display: inline-flex;
  margin: 0;
  padding: 0;
   text-align: center;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
}

.croon{
  display: block;
}

.villa{
  margin-top: 35px;
  border-radius: 15px;
}

.villa1{
  margin-top: 0;
  padding-top: 0;
   border-radius: 15px;
   margin-bottom: 100px;
}

.lucky{
  border: none;
 display: flex;
 width: 400px;
}

.lucky a{
text-decoration: none;
font-family: Montserrat;
font-size: 13px;
font-style: normal;
font-weight: bold;
line-height: 120%;
margin-left: 20px;
margin-top: 30px;
color: #761D9F;
}

.lucky a:hover{
  color: #000;
}

.lucky1{
  border: none;
 display: flex;
 text-align: justify;
 width: 400px;
}

.lucky1 a{
text-decoration: none;
font-family: Montserrat;
font-size: 22px;
font-style: normal;
font-weight: bold;
line-height: 1.2;
margin-left: 17px;
margin-top: 10px;
color: #000;
gap: 5px;
}

.lucky1 a:hover{
  color: #761D9F;
}

.lucky1new{
  border: none;
 display: flex;
 text-align: justify;
 width: 200px;
}

.lucky1new a{
text-decoration: none;
font-family: Montserrat;
font-size: 18px;
font-style: normal;
font-weight: bold;
line-height: 1.2;
margin-left: 17px;
margin-top: 10px;
color: #000;
gap: 5px;
}

.lucky1new a:hover{
  color: #761D9F;
}

.lucky2{
  border: none;
 display: flex;
 text-align: justify;
 width: 400px;
}

.lucky2 a{
text-decoration: none;
font-family: Montserrat;
font-size: 21px;
font-style: normal;
font-weight: bold;
line-height: 1.2;
margin-left: 17px;
color: #000;
gap: 5px;
}

.lucky2 a:hover{
  color: #761D9F;
}

.sabath{
 font-family: Montserrat;
font-size: 17px;
font-style: normal;
line-height: 1.2;
margin-left: 17px;
margin-top: 10px; 
text-align: justify;
color: #424242;
width: 400px;
}

.sabath2{
  margin-top: 0;
   font-family: Montserrat;
font-size: 17px;
font-style: normal;
line-height: 1.2;
margin-left: 17px; 
text-align: justify;
color: #424242;
width: 400px;
}

.sabath1{
 font-family: Montserrat;
font-size: 17px;
font-style: normal;
line-height: 1.1;
margin-left: 17px;
margin-top: 5px;
padding-top: 0; 
text-align: justify;
color: #424242;
width: 400px;
}

.pius{
  display: inline-flex;
  text-align: center;
  justify-content: center;
  align-items: center;
   font-family: Montserrat;
font-size: 19px;
font-style: normal;
line-height: 1.1;
text-align: justify;
padding-top: 0;
margin-top: 0;
margin-right: 50px;
}

.jolie{
  border: none;
 display: flex;
}

.jolie a{
text-decoration: none;
font-family: Montserrat;
font-size: 19px;
font-style: normal;
font-weight: bold;
line-height: 120%;
margin-top: 30px;
color: #000;
}

.jolie a:hover{
  color: #761D9F;
}

.pius-son{
  margin-right: 25px;
}

.pius-cuzo{
  margin-right: 10px;
}

.pius-cuzo1{
  padding-bottom:27px;
  margin-right: 56px;
}

.pius8{
  display: inline-flex;
  text-align: center;
  justify-content: center;
  align-items: center;
   font-family: Montserrat;
font-size: 15px;
font-style: normal;
line-height: 1.1;
text-align: justify;
padding-top: 0;
margin-top: 0;
margin-bottom: 100px;
margin-right: 100px;

}

.jolie8{
  border: none;
 display: flex;
}

.jolie8 a{
text-decoration: none;
font-family: Montserrat;
font-size: 15px;
font-style: normal;
font-weight: bold;
line-height: 120%;
margin-top: 30px;
color: #000;
}

.jolie8 a:hover{
  color: #761D9F;
}

.pius-son8{
  margin-right: 25px;
}

.pius-cuzo8{
  margin-right: 10px;
}

.pius-cuzo18{
  padding-bottom:27px;
  margin-right: 56px;
}

.pius2{
  display: inline-flex;
  text-align: center;
  justify-content: center;
  align-items: center;
   font-family: Montserrat;
font-size: 19px;
font-style: normal;
line-height: 1.1;
text-align: justify;
margin-bottom: 100px;
margin-right: 50px;
}

.jolie2{
  border: none;
 display: flex;
}

.jolie2 a{
text-decoration: none;
font-family: Montserrat;
font-size: 19px;
font-style: normal;
font-weight: bold;
line-height: 120%;
margin-top: 30px;
color: #000;
}

.jolie2 a:hover{
  color: #761D9F;
}

.pius-son2{
  margin-left: 0;
}

.pius-cuzo2{ 
  margin-right: 10px;
 
}

.pius-cuzo3{
 margin-bottom: 28px;
 margin-right: 50px;
}


.face{
  display: inline-flex;
  text-align: center;
  justify-content: center;
  align-items: center;
   font-family: Montserrat;
font-size: 19px;
font-style: normal;
line-height: 1.1;
text-align: justify;
padding-top: 0;
margin-top: 0;
margin-left: 25px;
margin-right: 50px;
}

.face-jolie{
  border: none;
 display: flex;
}

.face-jolie a{
text-decoration: none;
font-family: Montserrat;
font-size: 19px;
font-style: normal;
font-weight: bold;
line-height: 120%;
color: #000;
}

.face-jolie a:hover{
  color: #761D9F;
}

.face-son{
  margin-right: 25px;
}

.face-cuzo{
  margin-left: 10px;
 margin-bottom: 20px;
}

.face-cuzo1{
  margin-left: 26px;
}

.tross{
  height: 1000px;
  background-color: #FFFFFF;
 color: #000;
box-shadow: 10px 10px 10px 10px rgba(0, 0, 0, 0.2);
margin-bottom: 2600px;
width:400px;
display: flexbox;
margin-left: 200px;
border-radius: 15px;
}








@media screen and (max-width: 1024px) {
  .question {
    font-size: 38px !important;
    text-align: center !important;
    margin-left: 0 !important;
  }


  .dope {
    width: 90% !important;
    height: auto !important;
    margin-right: 0 !important;
    padding: 20px;
  }

  .dopeson {
    margin-right: 0 !important;
    justify-content: center !important;
    width: 100%;
  }

  .virg, .virg1 {
    flex-direction: column !important; 
    width: 100% !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .dapes, .tross {
    width: 90% !important;
    margin: 20px auto !important;
    height: auto !important;
    padding-bottom: 20px;
  }


  .clerk {
    width: 100% !important;
    justify-content: center !important;
  }

  .lucky, .lucky1, .lucky2, .sabath, .sabath1, .sabath2 {
    width: 100% !important;
    max-width: 500px;
  }
}

@media screen and (max-width: 430px) {
  .question {
    font-size: 28px !important;
    text-align: center !important;
    margin-left: 0 !important;
    padding: 0 10px;
  }

  .blogbeep, .blogbeep1 {
    padding: 20px 0 !important;
  }

  .dope {
    width: 95% !important;
    height: auto !important;
    margin-top: 10px !important;
  }

  .dopeson {
    flex-direction: column !important; 
    align-items: center !important;
    margin: 10px 0 !important;
  }

  .cook {
    padding-top: 10px !important;
    margin-left: 0 !important;
    font-size: 24px !important;
  }

  .dope img {
    width: 150px !important;
    height: 150px !important;
  }


  .dapes {
    width: 95% !important;
    margin-bottom: 20px !important;
  }

  .tross {
    width: 95% !important;
    margin-left: 0 !important;
    margin-bottom: 40px !important;
    box-shadow: 0 4px 10px rgba(0,0,0,0.1) !important;
  }


  .clerk {
    flex-direction: column !important; 
    align-items: center !important;
    margin-bottom: 40px !important;
  }

  .villa {
    width: 90% !important;
    height: auto !important;
    margin-top: 10px !important;
  }

  .croon {
    width: 100% !important;
    padding: 0 15px;
  }

 
  .lucky, .lucky1, .lucky2, .sabath, .sabath1, .sabath2 {
    width: 100% !important;
    text-align: center !important;
  }

  .lucky a { margin-left: 0 !important; justify-content: center; }
  .lucky1 a, .lucky2 a { font-size: 18px !important; margin-left: 0 !important; }
  .sabath, .sabath1, .sabath2 { margin-left: 0 !important; font-size: 15px !important; }

  .pius, .pius2, .pius8 {
    margin-right: 0 !important;
    justify-content: center !important;
    font-size: 14px !important;
    width: 100% !important;
  }


  .clerk1 {
    flex-direction: column !important;
    margin-left: 0 !important;
    padding: 10px;
  }

  .villa1 {
    margin-bottom: 10px !important;
  }

  .lucky1new { width: 100% !important; text-align: center !important; }
  .lucky1new a { margin-left: 0 !important; font-size: 16px !important; }
}
</style>